export default __webpack_public_path__ + "static/media/svelte.47c35757.svg";